// Preferiti "Orbit Desktop": cache in-memory + persistenza per-account (backend).
// Modello minimale per Preferito: { group, section }. Nessun sistema di navigazione parallelo.
import { api } from "@/lib/api";

export const FAVORITES_EVENT = "orbit-favorites-change";
export const FAV_NAV_EVENT = "orbit-favorites-navigate";

let _cache = null;
let _pendingNav = null;

export async function loadFavorites(force = false) {
  if (_cache && !force) return _cache;
  try {
    const { data } = await api.get("/me/desktop-favorites");
    _cache = Array.isArray(data?.favorites) ? data.favorites : [];
  } catch (_) {
    _cache = [];
  }
  return _cache;
}

export function getFavoritesCache() {
  return _cache || [];
}

export function clearFavoritesCache() {
  _cache = null;
}

export function isFav(group, section) {
  return (_cache || []).some((f) => f.group === group && f.section === section);
}

export async function toggleFavorite(group, section) {
  const cur = _cache || (await loadFavorites());
  const exists = cur.some((f) => f.group === group && f.section === section);
  const next = exists
    ? cur.filter((f) => !(f.group === group && f.section === section))
    : [...cur, { group, section }]; // nuovo Preferito sempre in fondo
  _cache = next;
  try { window.dispatchEvent(new CustomEvent(FAVORITES_EVENT)); } catch (_) {}
  try { await api.put("/me/desktop-favorites", { favorites: next }); } catch (_) {}
  return next;
}

// Salva l'ordine scelto dal drag & drop (riusa la stessa persistenza dei Preferiti).
export async function setFavoritesOrder(list) {
  const next = (list || []).map((f) => ({ group: f.group, section: f.section }));
  _cache = next;
  try { window.dispatchEvent(new CustomEvent(FAVORITES_EVENT)); } catch (_) {}
  try { await api.put("/me/desktop-favorites", { favorites: next }); } catch (_) {}
  return next;
}

// Deep-link verso una sezione Ufficio riusando lo stato interno di OfficeHome.
export function requestFavNav(group, section) {
  _pendingNav = { group, section };
  try { window.dispatchEvent(new CustomEvent(FAV_NAV_EVENT, { detail: { group, section } })); } catch (_) {}
}

export function consumePendingNav() {
  const p = _pendingNav;
  _pendingNav = null;
  return p;
}
